import { render, staticRenderFns } from "./_AdvertsWrapper.vue?vue&type=template&id=07f36780&scoped=true&"
import script from "./_AdvertsWrapper.vue?vue&type=script&lang=js&"
export * from "./_AdvertsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f36780",
  null
  
)

export default component.exports